import {
  directMailIcon,
  emailIcon,
  inPersonIcon,
  phoneIcon,
  socialIcon,
  textIcon,
  videoIcon,
} from '@/assets/images';
import InteractionType from '@/constants/InteractionType';
import translate from '@/lib/intl/translate';

const InteractionMethodFieldConfig = [
  {
    value: InteractionType.EMAIL,
    icon: emailIcon,
    text: translate('INTERACTION_METHOD_EMAIL'),
  },
  {
    value: InteractionType.IN_PERSON,
    icon: inPersonIcon,
    text: translate('INTERACTION_METHOD_IN_PERSON'),
  },
  {
    value: InteractionType.VIDEO,
    icon: videoIcon,
    text: translate('INTERACTION_METHOD_VIDEO_CALL'),
  },
  {
    value: InteractionType.PHONE,
    icon: phoneIcon,
    text: translate('INTERACTION_METHOD_PHONE_CALL'),
  },
  {
    value: InteractionType.TEXT,
    icon: textIcon,
    text: translate('INTERACTION_METHOD_TEXT'),
  },
  {
    value: InteractionType.SOCIAL,
    icon: socialIcon,
    text: translate('INTERACTION_METHOD_SOCIAL'),
  },
  {
    value: InteractionType.DIRECT_MAIL,
    icon: directMailIcon,
    text: translate('INTERACTION_METHOD_DIRECT_MAIL'),
  },
];

export default InteractionMethodFieldConfig;
